App.addModule(function(app) {

    app.onConsent('youtube', () => {
		    
        app.on('loaded', () => {

		    $('img[data-youtube-preview-url]').each(function() {
			    this.src = $(this).data('youtube-preview-url');
		    });
		    
		    $(document).on('click', '[data-toggle="youtube"]', function(event) {
			    
			    event.preventDefault();
			    
			    var $this = $(this);
			    
			    var iframe = document.createElement('iframe');
			    iframe.setAttribute('frameborder', '0');
			    iframe.setAttribute('allowfullscreen', '');
			    iframe.setAttribute('src', $this.data('embed-url'));
			    
			    $this.empty();
			    $this.append(iframe);
		    });
	    })
    })
})
